const normalizeText = (value) => String(value ?? '').trim();

export const isUseObjectAction = (action) => {
  const key = normalizeText(action?.standardActionKey).toLowerCase();
  const name = normalizeText(action?.name || action?.displayName).toLowerCase();
  const requirement = normalizeText(action?.targetRequirement || action?.targetType).toLowerCase();

  return key === 'use-object'
    || name === 'use an object'
    || requirement === 'object';
};

export const isSceneObjectToken = (token) => {
  const type = normalizeText(token?.type).toLowerCase();
  const kind = normalizeText(token?.kind || token?.tokenType).toLowerCase();
  return Boolean(token) && (
    token.isSceneObject === true
    || type === 'object'
    || kind === 'object'
  );
};

export const buildObjectInteractionAction = (action, { targetToken = null, objectName = '' } = {}) => {
  if (targetToken && !isSceneObjectToken(targetToken)) {
    throw new Error('Use an Object can only target a scene-object token.');
  }

  const resolvedName = normalizeText(targetToken?.name || objectName || action?.objectName);
  if (!resolvedName) {
    throw new Error('Choose an object token or enter the object name.');
  }

  const objectTokenId = targetToken?.id || action?.objectTokenId || null;
  const objectId = targetToken?.objectId || targetToken?.sceneObjectId || objectTokenId || action?.objectId || null;
  const objectEffect = normalizeText(
    targetToken?.interactionHint
      || targetToken?.interaction?.hint
      || targetToken?.behavior?.interactionHint
      || action?.objectEffect
  );

  return {
    ...action,
    objectName: resolvedName,
    ...(objectId ? { objectId } : {}),
    ...(objectTokenId ? { objectTokenId, targetId: objectTokenId } : {}),
    ...(objectEffect ? { objectEffect } : {})
  };
};

const ObjectInteractionTargeting = {
  isUseObjectAction,
  isSceneObjectToken,
  buildObjectInteractionAction
};

export default ObjectInteractionTargeting;
